import { cn } from '../../lib/utils';

/** Styled range slider with live value label. */
export default function Slider({ label, value, min, max, step = 1, onChange, suffix, className }) {
  const pct = ((value - min) / (max - min)) * 100;
  return (
    <div className={cn('w-full', className)}>
      {label && (
        <div className="mb-2 flex items-center justify-between text-sm">
          <span className="text-content-muted">{label}</span>
          <span className="font-mono text-content">
            {value}
            {suffix}
          </span>
        </div>
      )}
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="aether-range h-1.5 w-full cursor-pointer appearance-none rounded-full bg-white/[0.08]"
        style={{
          background: `linear-gradient(to right, rgb(109 94 252) ${pct}%, rgb(255 255 255 / 0.08) ${pct}%)`,
        }}
      />
      <style>{`
        .aether-range::-webkit-slider-thumb {
          -webkit-appearance: none;
          height: 18px; width: 18px; border-radius: 9999px;
          background: #fff; cursor: pointer;
          box-shadow: 0 0 0 4px rgb(109 94 252 / 0.35);
          transition: box-shadow .15s ease;
        }
        .aether-range::-webkit-slider-thumb:hover { box-shadow: 0 0 0 6px rgb(109 94 252 / 0.45); }
        .aether-range::-moz-range-thumb {
          height: 18px; width: 18px; border: none; border-radius: 9999px;
          background: #fff; cursor: pointer; box-shadow: 0 0 0 4px rgb(109 94 252 / 0.35);
        }
      `}</style>
    </div>
  );
}
